import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import Calculator from "../components/IndexPage/Calculator";
import ShopOfflineTerms from "../components/Shop/ShopOfflineTerms";
import ShopOfflineProduct from "../components/Shop/ShopOfflineProduct";
import { SEOText } from "./UserInterface/SEOText";
import PromoCTASection from "../components/PromoCTASection/PromoCTASection";

type KreditPagesProps = {
  query: string;
  asPath: string;
  item: any;
  seoTitle?: string;
  seoText?: string;
};
const KreditPages = ({
  query,
  asPath,
  item,
  seoTitle,
  seoText
}: KreditPagesProps) => {
  const { name, subtitle, meta_title, meta_desc, url } = item;

  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": process.env.baseURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseURL + asPath,
        name: name
      }
    }
  ];
  return (
    <Layout>
      <NextHead
        title={meta_title}
        description={meta_desc}
        url={asPath}
        breadcrumb={breadcrumb}
        tracker={query}
      />
      <ShopOfflineProduct title={name} subtitle={subtitle} path="" />
      {url && <Calculator />}
      <ShopOfflineTerms />
      <PromoCTASection title="SEGAMPANG ITU!">
        <b>Penuhi Kebutuhanmu</b>, lihat berbagai penawaran menarik ini  
      </PromoCTASection>
      {seoText && <SEOText title={seoTitle} text={seoText}></SEOText>}
    </Layout>
  );
};

export default KreditPages;
